import { render, staticRenderFns } from "./titleBarBlock.vue?vue&type=template&id=208fc147&scoped=true"
import script from "./titleBarBlock.vue?vue&type=script&lang=js"
export * from "./titleBarBlock.vue?vue&type=script&lang=js"
import style0 from "./titleBarBlock.vue?vue&type=style&index=0&id=208fc147&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208fc147",
  null
  
)

export default component.exports